import { Filter, GlProgram } from 'pixi.js';

const fragment = `
#version 300 es
precision highp float;
in vec2 vTextureCoord;
out vec4 finalColour;
uniform sampler2D uTexture;
uniform vec4 uInputSize;

uniform vec3 uColour;
uniform vec3 uLightColour;
uniform vec3 uDarkColour;

void main(void) {

    vec4 original = texture(uTexture, vTextureCoord);
    if (original.a < 0.01) { finalColour = vec4(0.0); return; } //don't process empty pixels

    vec3 rgb = original.rgb/original.a;

    float lum = dot(rgb, vec3(1.0/3.0));
    vec3 shifted = uColour;
    if (lum > 0.5) {
        float t = (lum - 0.5) / 0.5;
        // t = mix(t, (1.0 - cos(t * 3.14159265)) / 2.0, 0.5);
        vec3 target = mix(uLightColour, vec3(1.0), t);
        shifted = mix(shifted, target, t);
    } else {
        float t = (0.5 - lum) / 0.5;
        // t = mix(t, (1.0 - cos(t * 3.14159265)) / 2.0, 0.5);
        vec3 target = mix(uDarkColour, vec3(0.0), t);
        shifted = mix(shifted, target, t);
    }
    vec4 final = original;
    final.rgb = shifted*original.a;

    finalColour = final;

}
`;

const vertex = `
in vec2 aPosition;
out vec2 vTextureCoord;
out vec2 vOut;

uniform vec4 uInputSize;
uniform vec4 uOutputFrame;
uniform vec4 uOutputTexture;
vec4 filterVertexPosition( void ) {
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;
    return vec4(position, 0.0, 1.0);
}
vec2 filterTextureCoord( void ) {
    return aPosition * (uOutputFrame.zw * uInputSize.zw);
}
void main(void) {
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
    vOut = aPosition;
}
`;

export class Colourise extends Filter {
    constructor(colour: number, lightColour: number, darkColour: number) {
        const toRGB = (c: number) => [
            ((c >> 16) & 0xff) / 255,
            ((c >> 8) & 0xff) / 255,
            (c & 0xff) / 255
        ];
        const [r1,g1,b1] = toRGB(colour);
        const [r2,g2,b2] = toRGB(lightColour);
        const [r3,g3,b3] = toRGB(darkColour);
        super({
            glProgram: GlProgram.from({ vertex, fragment, name: 'midtone-tint-filter' }),
            resources: {
                uniforms: {
                    uColour: { value: [r1,g1,b1], type: 'vec3<f32>' },
                    uLightColour: { value: [r2,g2,b2], type: 'vec3<f32>' },
                    uDarkColour:  { value: [r3,g3,b3], type: 'vec3<f32>' },
                }
            }
        });
    }

    set colour(value: number) {
        const r = ((value >> 16) & 0xff) / 255;
        const g = ((value >> 8) & 0xff) / 255;
        const b = (value & 0xff) / 255;
        this.resources.uniforms.uniforms.uColour = [r,g,b]
    }

    set lightColour(value: number) {
        const r = ((value >> 16) & 0xff) / 255;
        const g = ((value >> 8) & 0xff) / 255;
        const b = (value & 0xff) / 255;
        this.resources.uniforms.uniforms.uLightColour = [r,g,b];
    }

    set darkColour(value: number) {
        const r = ((value >> 16) & 0xff) / 255;
        const g = ((value >> 8) & 0xff) / 255;
        const b = (value & 0xff) / 255;
        this.resources.uniforms.uniforms.uDarkColour = [r,g,b];
    }

}